module.exports = __webpack_public_path__ + "img/hr-rock-medium-02.e8d88f1c.png";